export default "__VITE_ASSET__81026aa8__"